// extracted by mini-css-extract-plugin
export default {"row":"styles_row__COSxb","cell":"styles_cell__80cTy","tableContainer":"styles_tableContainer__fvjLE","buttonMenu":"styles_buttonMenu__Lu6fj"};